import { format, parseISO } from 'date-fns';
import helpers from '../../helper';
import {GETTERS, MUTATIONS} from '../constants';
import { yoyoHttp } from '../../services/http.service';
import {type} from "os";

function isCustomsShipment(state, pickupAddress, receiverAddress, shipDate) {
    if (pickupAddress == null || receiverAddress == null) {
        return true;
    }
    const receiverCountry = state.countries.filter((c) => {
        return c.countryCode === receiverAddress.countryCode;
    });

    const pickupCountry = state.countries.filter((c) => {
        return c.countryCode === pickupAddress.countryCode;
    });

    if (receiverCountry.length < 1 || pickupCountry.length < 1) {
        return true;
    }

    if (receiverCountry[0].countryCode === pickupCountry[0].countryCode) {
        return false;
    }

    let isReceiverCountryEu = receiverCountry[0].isEuCountry;
    let isPickupCountryEu = pickupCountry[0].isEuCountry;
    

    if (isReceiverCountryEu && isPickupCountryEu) {
        let customsRequiredReceiverCountryPostalCode = isCustomsRequiredForPostalCode(receiverAddress.postalCode, receiverCountry[0].countryCode);
        let customsRequiredPickupCountryPostalCode = isCustomsRequiredForPostalCode(pickupAddress.postalCode, pickupCountry[0].countryCode);
        if (customsRequiredReceiverCountryPostalCode == true || customsRequiredPickupCountryPostalCode == true) {
            return true;
        }
        return false;
    }

    var customsFreeReceiverCountryPostalCode = isCustomsFreePostalCode(receiverAddress.postalCode, state.customsFreeZones, receiverCountry[0].countryCode, shipDate);
    var customsFreePickupCountryPostalCode = isCustomsFreePostalCode(pickupAddress.postalCode, state.customsFreeZones, pickupCountry[0].countryCode, shipDate);

    if (customsFreeReceiverCountryPostalCode == true || customsFreePickupCountryPostalCode == true) {
        return false;
    }
    return true;
}

function isCustomsRequiredForPostalCode(postalCode,countryCode) {
    if (countryCode == "FI" && postalCode.startsWith("22")){
        return true;
    }
    // Spain (Canary Islands etc.)
    if (countryCode === "ES") {
        const prefix = postalCode.substring(0, 2);

        const specialPrefixes = ["35", "38"]; // Canary Islands

        const specialFullCodes = [
            "51001","51002","51003","51004","51005",
            "52001","52002","52003","52004","52005","52006"
        ];

        if (specialPrefixes.includes(prefix) || specialFullCodes.includes(postalCode)) {
            return true;
        }
    }


    return false;
}

function isCustomsFreePostalCode(postalCode, customsFreeZones, countryCode, shipDate) {

    let result = false;

    if (postalCode != null) {
        // Check for "BT" or "bt" prefix and shipDate condition
        if (countryCode.toLowerCase() === "gb" && postalCode.toLowerCase().startsWith("bt")) {
            if (isShipDateAfterCutoff(shipDate, "2025-04-01T00:00:00.000Z")) {
                return false;
            }
        }
        
        let customsFreeZone = customsFreeZones.find(x => x.countryCode === countryCode);

        if (customsFreeZone != undefined) {

            for (const customsFreePostalCode of customsFreeZone.postalCodes) {

                if (postalCode == customsFreePostalCode) {
                    result = true;
                    break;
                }

                if (customsFreePostalCode.includes("*")) {
                    result = postalCode.startsWith(customsFreePostalCode.split('*')[0]);

                    if (result) {
                        break;
                    }
                }
            }
        }
    }

    return result;
}

function isShipDateAfterCutoff(shipDate, cutoffDateString) {
    let cutoffDate = new Date(cutoffDateString);

    if (!shipDate) {
        return false;
    }

    let shipDateToCompare = shipDate;

    if (typeof shipDate === 'string') {
        shipDateToCompare = new Date(shipDate);
    }

    if (shipDateToCompare > cutoffDate) {
        return true;
    }

    return false;
}

function isEU(receiverCountry, pickupCountry, shipDate) {
    if (shipDate) {
        if (receiverCountry.euResignationDate != null) {
            return new Date(receiverCountry.euResignationDate) <= new Date(shipDate);
        }

        if (pickupCountry.euResignationDate != null) {
            return new Date(pickupCountry.euResignationDate) <= new Date(shipDate);
        }
    }
    return true;
}

function isCustomsShipmentAndNotDocument(state, document, pickupAddress, receiverAddress, shipDate) {
    if (document) {
        return false;
    }

    return isCustomsShipment(state, pickupAddress, receiverAddress, shipDate);
}

function ensureShipDateAppliedToPickup(shipment) {
    const shipDate = parseISO(shipment.shipDate);
    const date = format(shipDate, 'yyyy-MM-dd');

    if(shipment.pickup.readyTime.length > 5){
        shipment.pickup.readyTime = "06:00"
    }

    if(shipment.pickup.closeTime.length > 5){
        shipment.pickup.closeTime = "17:00"
    }

    const readyTime = date + 'T' + shipment.pickup.readyTime + ':00.0000+00:00'; // UTC
    const closeTime = date + 'T' + shipment.pickup.closeTime + ':00.0000+00:00'; // UTC
    const pickup = {
        readyTime,
        closeTime
    };

    shipment.pickup = pickup;
}

const getters = {
    getBackendErrorByKey: (state) => (key) => {
        return state.backendErrors.find((e) => e.key === key);
    },

    hasBackendValidationError: (state) => (key) => {
        return state.backendErrors.find((e) => e.key === key) != null;
    },

    getReferenceTypes: (state) => {
        return state.referenceTypes;
    },

    getPrototype: (state) => {
        return state.prototype;
    },

    getServicePrices: (state) => {
        return state.servicePrices;
    },

    getViewOptions: (state) => {
        return state.bookingOptions.viewOptions;
    },

    getShipment: (state) => {
        return state.shipment;
    },

    hasShipmentOptions: (state) => {
        return (
            state.shippingOptions.products !== undefined &&
            state.shippingOptions.products.length > 0
        );
    },

    isInsuranceRequired: (state) => {
        let viewOptions = state.bookingOptions.viewOptions;
        if (!viewOptions)
            return false;

        const isDisplayed = viewOptions.filter((opt) => {
            return opt.name === 'NoInsurance';
        })[0];

        return isDisplayed.display && !state.insuranceAmountRequired;
    },
    
    isDefaultShipmentTypeDocument: (state) => {
        let viewOptions = state.bookingOptions.viewOptions;
        if (!viewOptions)
            return false;

        const isDisplayed = viewOptions.filter((opt) => {
            return opt.name === 'DefaultShipmentTypeDocument';
        })[0];

        return state.isDefaultShipmentTypeDocument;
    },
    isDangerousGoods: (state) => {
        return state.isDangerousGoods;
    },

    getSelectedCompanyAccount: (state, getters, rootState) => {
        const result = rootState.core.companyAccounts.find((c) => {
            return c.id === rootState.core.companyAccountId;
        });

        return result;
    },

    getSelectedCompany: (state, getters, rootState) => {
        const result = rootState.core.companies.filter((c) => {
            return c.id === state.selectedCompanyId;
        });
        return result;
    },

    getDangerousGoodsDescriptions(state) {
        return state.dangerousGoodsDescriptions;
    },

    getListOfDgTypes(state) {
        return state.dangerousGoodsTypes;
    },

    getReceiverPaysTransportProducts(state, getters, rootState) {
        const result = rootState.core.transportProducts.filter((c) => {
            return c.isReceiverPays;
        });
        return result;
    },

    getListOfInsuranceCurrencies(state, getters, rootState) {
        return rootState.core.currencies.filter((obj) => {
            return (
                obj.currencyCode === 'DKK' ||
                obj.currencyCode === 'EUR' ||
                obj.currencyCode === 'GBP' ||
                obj.currencyCode === 'SEK' ||
                obj.currencyCode === 'NOK' ||
                obj.currencyCode === 'USD'
            );
        });
    },
    getAddressBook: (state) => {
        return state.addressBook;
    },

    getListOfCustomerDescriptions: (state) => {
        return state.customerDescriptions;
    },

    getSelectedCompanyId: (state) => {
        return state.selectedCompanyId;
    },

    getShippingOptions: (state) => {
        return state.shippingOptions;
    },

    getBackendErrors: (state) => {
        return state.backendErrors;
    },

    getIsColliDimension: (state) => {
        return state.isColliDimension;
    },

    getDefaultColliDimension: (state) => {
        if (state.bookingOptions.viewOptions) {
            const element = state.bookingOptions.viewOptions.find((obj) => {
                return obj.name === 'PackageDimensions';
            });
            if (element) {
                return element.display;
            }
        }
        else {
            return true;
        }
    },

    getIsDangerousGoods: (state) => {
        return state.isDangerousGoods;
    },

    getLabelUrl: (state) => {
        return state.labelUrl;
    },
    
    getTrackingNumber: (state) => {
        return state.trackingNumber
    },

    getDefaultValues: (state) => {
        return state.defaultValues;
    },

    requireCustoms: (state, getters, rootState) => {
        return isCustomsShipmentAndNotDocument(
            rootState.core,
            state.shipment.shipmentOptions.isDocument,
            state.shipment.pickupAddress,
            state.shipment.receiverAddress,
            state.shipment.shipDate
        );
        return;
    },

    shipmentForBackend: (state, getters, rootState) => {
        const result = helpers.cloneObject(state.shipment); // JSON.parse(JSON.stringify(state.shipment));
        result.accountId = rootState.core.companyAccountId;
        

        const requireCustoms = isCustomsShipmentAndNotDocument(
            rootState.core,
            result.shipmentOptions.isDocument,
            result.pickupAddress,
            result.receiverAddress,
            result.shipDate
        );

        if (!requireCustoms) {
            result.customsAmount = null;
        }

        if (result.shipmentOptions != null && result.shipmentOptions.isDocument) {
            result.customsAmount = null;
        }

        if (result.pickup != null) {
            ensureShipDateAppliedToPickup(result);
        }

        if (result.receiverPays != null) {
            result.insuranceAmount = null;
        }
        result.shipDate = result.shipDate.slice(0,10);
        return result;
    },

    isCustomsShipment: (state, getters, rootState) => (pickupAddress, receiverAddress, shipDate) => {
        const result = isCustomsShipment(rootState.core, pickupAddress, receiverAddress, shipDate);

        return result;
    },

    isCustomsShipmentAndNotDocument: (state, getters, rootState) => (
        document,
        pickupAddress,
        receiverAddress,
        shipDate
    ) => {
        const result = isCustomsShipmentAndNotDocument(
            rootState.core,
            document,
            pickupAddress,
            receiverAddress,
            shipDate
        );
        return result;
    },

    insuranceRequired: (state) => {
        if (state.bookingOptions.viewOptions != undefined) {
            const element = state.bookingOptions.viewOptions.find((obj) => {
                return obj.name === 'NoInsurance';
            });

            if (element != undefined) {
                return element.display;
            }
        }

        return false;
    },
    defaultShipmentTypeDocument : (state) => {
        if (state.bookingOptions.viewOptions != undefined) {
            const element = state.bookingOptions.viewOptions.find((obj) => {
                return obj.name === 'DefaultShipmentTypeDocument';
            });
            
            if (element != undefined) {
                return element.display;
            }
        }
        return false;
    },
    [GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING_ACTIVE]: (state) => {
        if (state.bookingOptions.viewOptions) {
            const element = state.bookingOptions.viewOptions.find((obj) => {
                return obj.name === 'ShipmentPackaging';
            });
            if (element) {
                return element.display;
            }
        }
        return false;
    },

    isReceiverPays: (state) => {
        return state.isReceiverPays;
    },
    [GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING]: (state) => {
        return state.shipmentPackaging.sort((a, b) => {
            // tslint:disable-next-line: one-variable-per-declaration
            const nameA = a.productName.toLowerCase(),
                nameB = b.productName.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    },
    [GETTERS.CREATE_SHIPMENT.PACKAGINGID_BY_TYPE]: (state) => (typeName) => {
        let result = state.packagingTypes.find((p) => p.packageType === typeName);
        if (typeName === 'Other') {
            result = state.packagingTypes.find((p) => p.name === typeName);
        }

        return result.id;
    },
    [GETTERS.CREATE_SHIPMENT.BLOCKED_DESCRIPTIONS]: async (state) => {
        const r = await yoyoHttp.cachedGet('/api/StaticData/BlockedDescriptions', null);
        if (r.status === 200) {
            return r.data;
        }
        return [];
    },
    
    getSenderAddress: (state) => {
        const sender = state.companyAccountAddresses.find((obj) => {
            return obj.accountTypeId === 3;
        });
        return sender;
    },
    getPickupAddress: (state) => {
        const pickup = state.companyAccountAddresses.find((obj) => {
            return obj.accountTypeId === 1;
        });
        return pickup;
    }
};

export default getters;
